module.exports = __webpack_public_path__ + "static/img/bg-fr.70fc3783.png";